var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
import { Table } from './Table';
export var TableArray = function (_a) {
    var design = _a.design, data = _a.data, values = _a.values, targetSource = _a.targetSource, globalDataSource = _a.globalDataSource;
    var _b = useDesign(design), schema = _b.schema, config = _b.config, components = _b.components;
    var usableSource = targetSource || config.targetSource;
    var usableDataOrigin = values || data || [];
    var usableData = get(usableDataOrigin, usableSource, usableDataOrigin) || {};
    var globalDataConfig = get(usableDataOrigin, config.globalDataSource, {});
    var globalDataProps = get(usableDataOrigin, globalDataSource, {});
    var globalData = __assign(__assign({}, globalDataConfig), globalDataProps);
    return (_jsx(GenericComponent, __assign({ schema: schema, as: "div", design: design }, { children: usableData === null || usableData === void 0 ? void 0 : usableData.map(function (table, tableIndex) {
            return (_jsx(Table, { design: components.repeatingTable, values: table, globalData: globalData }, "tableSet".concat(tableIndex)));
        }) })));
};
TableArray.displayName = 'TableArray';
